import { Link } from "react-router-dom";
import { navLinks } from "@/mocks/company";

const serviceSubLinks = [
  { label: "各種環境試験", to: "/service" },
  { label: "ガス腐食試験 無料体験", to: "/service/free-trial" },
  { label: "受託試験のご案内", to: "/service/test-guide" },
  { label: "ガス腐食・接触抵抗 料金表", to: "/service/test-guide/gas-corrosion" },
  { label: "その他環境試験 料金表", to: "/service/test-guide/env-test" },
];

const productsSubLinks = [
  { label: "ガス腐食試験機 KG200", to: "/products#kg200" },
  { label: "ガス腐食試験機 KG600", to: "/products#kg600" },
  { label: "接触抵抗評価装置 MS7500", to: "/products#ms7500" },
  { label: "ドライアルファ", to: "/products#dryalfa" },
  { label: "資料カタログ", to: "/products#catalog" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-background-100">
      {/* Main footer */}
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/46c769b0-62ed-4752-96b8-d59840c4cf62/ec62d72a-5c80-4516-858a-bd62c54258ee_compressed_IMG_5463-2.webp"
                alt="ファクトケイ"
                className="w-9 h-9 rounded-md object-contain bg-background-50"
              />
              <div>
                <span className="font-bold text-base">ファクトケイ</span>
                <span className="ml-1 text-xs text-background-300">株式会社</span>
              </div>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              接触機構部品のガス腐食試験、接触抵抗評価分析、メタルコンタクト表面処理液の専門企業
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-bold text-sm mb-4 text-background-50">サイト案内</h4>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {/* Left column: ホーム, お知らせ, サービス */}
              <div>
                <ul className="space-y-2">
                  {navLinks.slice(0, 3).map((link) => {
                    if (link.path === "/service") {
                      return (
                        <li key={link.path}>
                          <Link
                            to={link.path}
                            className="text-sm text-background-300 hover:text-accent-300 transition-colors"
                          >
                            {link.label}
                          </Link>
                          <ul className="mt-1.5 ml-3 space-y-1 border-l border-secondary-600 pl-3">
                            {serviceSubLinks.map((sub) => (
                              <li key={sub.to}>
                                <Link
                                  to={sub.to}
                                  className="text-xs text-background-400 hover:text-accent-300 transition-colors"
                                >
                                  {sub.label}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      );
                    }
                    return (
                      <li key={link.path}>
                        <Link
                          to={link.path}
                          className="text-sm text-background-300 hover:text-accent-300 transition-colors"
                        >
                          {link.label}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
              {/* Right column: 製品 */}
              <div>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/products"
                      className="text-sm text-background-300 hover:text-accent-300 transition-colors"
                    >
                      製品
                    </Link>
                    <ul className="mt-1.5 ml-3 space-y-1 border-l border-secondary-600 pl-3">
                      {productsSubLinks.map((sub) => (
                        <li key={sub.to}>
                          <Link
                            to={sub.to}
                            className="text-xs text-background-400 hover:text-accent-300 transition-colors"
                          >
                            {sub.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-sm mb-4 text-background-50">その他</h4>
            <ul className="space-y-2">
              {navLinks.slice(4).map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-accent-300 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-sm mb-4 text-background-50">お問い合わせ</h4>
            <p className="text-sm text-background-300 mb-2">
              〒146-0084
              <br />
              東京都大田区南久が原2-23-19
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 mt-3 px-4 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <span>お問い合わせ</span>
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="border-t border-secondary-700">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-400">
            Copyright (C) Fact K Co., Ltd. All Rights Reserved.
          </p>
          <p className="text-xs text-background-400">
            ファクトケイ株式会社
          </p>
        </div>
      </div>
    </footer>
  );
}